import { cn } from "@/lib/utils";

// Platform logo. `?v=2` busts caches after the logo swap.
export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/brand/logo.png?v=2`;

export function BrandLogo({ className, alt = "ArcQuan Platform" }) {
  return (
    <img
      src={BRAND_LOGO_SRC}
      alt={alt}
      draggable={false}
      className={cn("object-contain", className)}
      data-testid="brand-logo"
    />
  );
}
